<p-confirmDialog key="confirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="result" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="MainMenu">
	<h4 class="CenterText">Schools to Update</h4>

	<p-table
		#mydt
		[value]="lstSchoolsToChange"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--SchoolID-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
				<!--School Name-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-school>
			<tr [pSelectableRow]="school">
				<td>
					<p-tableCheckbox [pSelectableRow]="school" [value]="school"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ school[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>

	<div class="Buttons">
		<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onAddSchool()">Add School(s)</button>
		<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onRemove()">Remove School(s)</button>
	</div>
</div>

<!--Top Menu-->
<div class="MainMenu TopMargin">
	<h4 class="CenterText">Zero Out Fines/Meals</h4>

	<div class="SectionGrid">
		<label style="margin: 0px">Choose Account(s):</label>
		<div class="CheckBoxGrid">
			<input [disabled]="isProcessing == true" id="ZeroFines" [(ngModel)]="ZeroFines" class="CHKStyle" type="checkbox" />
			<label for="ZeroFines" style="margin: 0px">Fines</label>

			<input [disabled]="isProcessing == true" id="ZeroMeals" [(ngModel)]="ZeroMeals" class="CHKStyle" type="checkbox" />
			<label for="ZeroMeals" style="margin: 0px">Meals</label>
		</div>

		<label style="margin: 0px">Adjustment Type(s):</label>
		<div class="CheckBoxGrid">
			<input [disabled]="isProcessing == true" id="AdjustStudent" [(ngModel)]="AdjustStudent" class="CHKStyle" type="checkbox" />
			<label for="AdjustStudent" style="margin: 0px">What Student Owes (Debit Account)</label>

			<input [disabled]="isProcessing == true" id="AdjustSchool" [(ngModel)]="AdjustSchool" class="CHKStyle" type="checkbox" />
			<label for="AdjustSchool" style="margin: 0px">What School Owes (Credit Account)</label>
		</div>

		<label style="margin: 0px">Range:</label>
		<div class="CheckBoxGrid">
			<input class="RadioBtn" type="radio" [(ngModel)]="FMRangeOption" name="FMRangeOption" id="FMAll" value="All" />
			<label for="FMAll">All</label>

			<input class="RadioBtn" type="radio" [(ngModel)]="FMRangeOption" name="FMRangeOption" id="FMDate" value="Date" />
			<label for="FMDate">Date Range</label>
		</div>

		<label *ngIf="FMRangeOption == 'Date'" style="margin: 0px">Date Range:</label>
		<div *ngIf="FMRangeOption == 'Date'" class="DateGrid">
			<p-calendar [(ngModel)]="FMStartDate" showIcon="true" showButtonBar="true"></p-calendar>
			<label style="margin: 0px">to</label>
			<p-calendar [(ngModel)]="FMEndDate" showIcon="true" showButtonBar="true"></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onProcessFinesMeals()">Process</button>

		<!-- <button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onPrintFinesMeals()">Print</button> -->
	</div>
</div>

<!--Merits Menu-->
<div class="MainMenu TopMargin" *ngIf="MeritAllowed == true">
	<h4 class="CenterText">Zero Out Merits/Demerits</h4>

	<div class="SectionGrid">
		<label style="margin: 0px">Range:</label>
		<div class="CheckBoxGrid">
			<input class="RadioBtn" type="radio" [(ngModel)]="MeritRangeOption" name="MeritRangeOption" id="MeritAll" value="All" />
			<label for="MeritAll">All</label>

			<input class="RadioBtn" type="radio" [(ngModel)]="MeritRangeOption" name="MeritRangeOption" id="MeritDate" value="Date" />
			<label for="MeritDate">Date Range</label>
		</div>

		<label *ngIf="MeritRangeOption == 'Date'" style="margin: 0px">Date Range:</label>
		<div *ngIf="MeritRangeOption == 'Date'" class="DateGrid">
			<p-calendar [(ngModel)]="MeritStartDate" showIcon="true" showButtonBar="true"></p-calendar>
			<label style="margin: 0px">to</label>
			<p-calendar [(ngModel)]="MeritEndDate" showIcon="true" showButtonBar="true"></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onProcessMeritsDemerits()">Process</button>
	</div>
</div>

<!--PBIS Menu-->
<div class="MainMenu TopMargin" *ngIf="PBISAllowed == true">
	<h4 class="CenterText">Zero Out PBIS</h4>

	<div class="SectionGrid">
		<label style="margin: 0px">Range:</label>
		<div class="CheckBoxGrid">
			<input class="RadioBtn" type="radio" [(ngModel)]="PBISRangeOption" name="PBISRangeOption" id="PBISAll" value="All" />
			<label for="PBISAll">All</label>

			<input class="RadioBtn" type="radio" [(ngModel)]="PBISRangeOption" name="PBISRangeOption" id="PBISDate" value="Date" />
			<label for="PBISDate">Date Range</label>
		</div>

		<label *ngIf="PBISRangeOption == 'Date'" style="margin: 0px">Date Range:</label>
		<div *ngIf="PBISRangeOption == 'Date'" class="DateGrid">
			<p-calendar [(ngModel)]="PBISStartDate" showIcon="true" showButtonBar="true"></p-calendar>
			<label style="margin: 0px">to</label>
			<p-calendar [(ngModel)]="PBISEndDate" showIcon="true" showButtonBar="true"></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="Buttons">
		<button [disabled]="isProcessing == true" class="btn btn-primary" (click)="onProcessPBIS()">Process</button>
	</div>
</div>

<!--Error Message-->
<div class="form-group TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>

<div class="form-group TopMargin">
	<div name="isProcessing" *ngIf="isProcessing" class="alert alert-info">Processing (NOTE: It may take a while to update the database).Please wait...</div>
</div>
